'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/round.js
// module id = 1675
// module chunks = 1